// extracted by mini-css-extract-plugin
export var cardContainer = "detail-module--cardContainer--DWR3w";
export var serchContainer = "detail-module--serchContainer--lAdSd";
export var serchDiscription = "detail-module--serchDiscription--6okDO";